var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDashboardTop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.5H26.25M8.75 3.75V6.25M21.25 3.75V6.25M7.75 26.25H22.25C23.6501 26.25 24.3503 26.25 24.885 25.9775C25.3554 25.7379 25.7379 25.3554 25.9775 24.885C26.25 24.3503 26.25 23.6501 26.25 22.25V10.25C26.25 8.84986 26.25 8.1498 25.9775 7.61503C25.7379 7.14461 25.3554 6.76216 24.885 6.52249C24.3503 6.25 23.6501 6.25 22.25 6.25H7.75C6.34987 6.25 5.6498 6.25 5.11503 6.52249C4.64461 6.76216 4.26216 7.14461 4.02249 7.61503C3.75 8.1498 3.75 8.84986 3.75 10.25V22.25C3.75 23.6501 3.75 24.3503 4.02249 24.885C4.26216 25.3554 4.64461 25.7379 5.11503 25.9775C5.6498 26.25 6.34986 26.25 7.75 26.25Z",
    stroke: "#3B82F6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDashboardTop2);
export default __webpack_public_path__ + "static/media/calendarDashboardTop2.772e9a65e4c5f5af43e31044742fe293.svg";
export { ForwardRef as ReactComponent };